import { meApi } from "@/config/httpClient"
import { MeDTO } from "@/generated/openapi"

class MeService {

  private mePerson: Promise<MeDTO> | null = null;

  private getMePerson(): Promise<MeDTO>{
    if(!this.mePerson){
      this.mePerson = meApi.me1().then(resp => resp.data);
    }
    return this.mePerson;
  }

  public getMe(): Promise<MeDTO> {
    return this.getMePerson();
  }

}

const meService = new MeService()
export default meService
